import { Component, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { DataCheckerService } from '@tokeet-frontend/tv3-platform'
import { SignaturePreferenceGuard } from '@tokeet-frontend/signature'
import { DocumentsPrefForm } from './documents-pref-form'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-documents-pref-form',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  templateUrl: './documents-pref-form.component.html',
  styles: [],
})
export class DocumentsPrefFormComponent extends DocumentsPrefForm {
  constructor(
    protected fb: UntypedFormBuilder,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    private dataChecker: DataCheckerService
  ) {
    super(fb, store, amplitudeService)
    this.dataChecker.check([SignaturePreferenceGuard])
  }
}
